import React, { memo } from 'react';
// @mui
import { Box } from '@mui/material';
//

// ----------------------------------------------------------------------

function EventEmpty({ ...other }) {
  return (
    <Box {...other}>
      <svg
        width="351"
        height="386"
        viewBox="0 0 351 386"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="175.038"
          cy="205.416"
          r="175.038"
          fill="#E1EFFF"
          fill-opacity="0.38"
        />
        <ellipse
          cx="174.996"
          cy="205.416"
          rx="143.656"
          ry="143.656"
          fill="#E1EFFF"
          fill-opacity="0.38"
        />
        <ellipse
          cx="174.954"
          cy="205.416"
          rx="112.275"
          ry="112.275"
          fill="#E1EFFF"
        />
        <rect
          x="10.7729"
          y="287.952"
          width="328.087"
          height="97.9365"
          fill="#FAFAFF"
        />
        <path
          d="M98.4507 274.059L34.0986 44.5362L50.4012 29.9497L242.599 260.33L98.4507 274.059Z"
          fill="url(#paint0_linear_32_6486)"
          fill-opacity="0.65"
        />
        <path
          d="M34.5103 45.6258L22.272 29.2031C20.2899 26.0885 22.5866 20.7716 26.4878 17.7828C29.7912 15.2344 34.1013 14.5108 36.4294 16.4929C40.8654 20.6143 45.8048 25.239 51.4363 30.4616L34.5103 45.6258Z"
          fill="#ABD1FF"
        />
        <path
          d="M44.9241 40.2145C40.142 44.4932 35.4228 46.8528 34.4161 45.4999C33.4408 44.1786 36.3352 39.8055 40.897 35.747C45.4589 31.6885 50.1151 29.2346 51.3106 30.3672C52.5376 31.4998 49.7061 35.9358 44.9241 40.2145Z"
          fill="#F3F8FF"
        />
        <path
          d="M33.1889 28.2907H31.8046C30.4833 28.2907 29.4136 27.2211 29.4136 25.8997V3.27922C29.4136 1.95786 30.4833 0.888184 31.8046 0.888184H33.1889C34.5103 0.888184 35.5799 1.95786 35.5799 3.27922V25.8997C35.5485 27.2211 34.5103 28.2907 33.1889 28.2907Z"
          fill="#80C6FF"
        />
        <path
          d="M239.596 269.339L315.102 45.8232L298.8 30.3787L89.4414 263.762L239.596 269.339Z"
          fill="url(#paint1_linear_32_6486)"
          fill-opacity="0.82"
        />
        <path
          d="M315.12 45.6258L327.358 29.2031C329.34 26.0885 327.044 20.7716 323.142 17.7828C319.839 15.2344 315.529 14.5108 313.201 16.4929C308.765 20.6143 303.825 25.239 298.194 30.4616L315.12 45.6258Z"
          fill="#ABD1FF"
        />
        <path
          d="M304.706 40.2145C309.488 44.4932 314.207 46.8527 315.214 45.4999C316.19 44.1785 313.295 39.8055 308.733 35.747C304.171 31.6571 299.515 29.2346 298.32 30.3672C297.093 31.4998 299.924 35.9358 304.706 40.2145Z"
          fill="#F3F8FF"
        />
        <path
          d="M316.441 28.2907H317.826C319.147 28.2907 320.217 27.2211 320.217 25.8997V3.27922C320.217 1.95786 319.147 0.888184 317.826 0.888184H316.441C315.12 0.888184 314.05 1.95786 314.05 3.27922V25.8997C314.082 27.2211 315.12 28.2907 316.441 28.2907Z"
          fill="#80C6FF"
        />
        <path
          d="M284.429 169.379H231.79C228.403 169.379 225.657 172.125 225.657 175.512V288.518C225.657 291.906 228.403 294.651 231.79 294.651H284.429C287.816 294.651 290.561 291.905 290.561 288.518V175.512C290.561 172.125 287.816 169.379 284.429 169.379Z"
          fill="#C2DBFF"
        />
        <path
          d="M274.573 207.982C274.573 217.066 267.209 224.429 258.125 224.429C249.041 224.429 241.678 217.066 241.678 207.982C241.678 198.898 249.041 191.534 258.125 191.534C267.209 191.534 274.573 198.898 274.573 207.982Z"
          fill="#ABD1FF"
          stroke="#EAF1FF"
          stroke-width="2.24386"
        />
        <path
          d="M258.86 207.982C258.86 208.388 258.531 208.717 258.125 208.717C257.719 208.717 257.39 208.388 257.39 207.982C257.39 207.575 257.719 207.246 258.125 207.246C258.531 207.246 258.86 207.575 258.86 207.982Z"
          fill="#EEF4FF"
          stroke="#EAF1FF"
          stroke-width="2.24386"
        />
        <path
          d="M276.975 256.031C276.975 266.442 268.536 274.881 258.125 274.881C247.714 274.881 239.275 266.442 239.275 256.031C239.275 245.621 247.714 237.182 258.125 237.182C268.536 237.182 276.975 245.621 276.975 256.031Z"
          fill="#ABD1FF"
          stroke="#EAF1FF"
          stroke-width="1.75221"
        />
        <path
          d="M259.334 256.031C259.334 256.699 258.792 257.24 258.124 257.24C257.457 257.24 256.915 256.699 256.915 256.031C256.915 255.363 257.457 254.822 258.124 254.822C258.792 254.822 259.334 255.363 259.334 256.031Z"
          fill="#EEF4FF"
          stroke="#EAF1FF"
          stroke-width="1.75221"
        />
        <path
          d="M116.691 169.379H64.0522C60.6652 169.379 57.9194 172.125 57.9194 175.512V288.518C57.9194 291.906 60.6652 294.651 64.0522 294.651H116.691C120.078 294.651 122.824 291.905 122.824 288.518V175.512C122.824 172.125 120.078 169.379 116.691 169.379Z"
          fill="#C2DBFF"
        />
        <path
          d="M106.835 207.982C106.835 217.066 99.4711 224.429 90.3874 224.429C81.3036 224.429 73.9398 217.066 73.9398 207.982C73.9398 198.898 81.3036 191.534 90.3874 191.534C99.4711 191.534 106.835 198.898 106.835 207.982Z"
          fill="#ABD1FF"
          stroke="#EAF1FF"
          stroke-width="2.24386"
        />
        <path
          d="M91.1225 207.982C91.1225 208.388 90.7932 208.717 90.3871 208.717C89.981 208.717 89.6517 208.388 89.6517 207.982C89.6517 207.575 89.981 207.246 90.3871 207.246C90.7932 207.246 91.1225 207.575 91.1225 207.982Z"
          fill="#EEF4FF"
          stroke="#EAF1FF"
          stroke-width="2.24386"
        />
        <path
          d="M109.237 256.031C109.237 266.442 100.798 274.881 90.3872 274.881C79.9767 274.881 71.5372 266.442 71.5372 256.031C71.5372 245.621 79.9767 237.182 90.3872 237.182C100.798 237.182 109.237 245.621 109.237 256.031Z"
          fill="#ABD1FF"
          stroke="#EAF1FF"
          stroke-width="1.75221"
        />
        <path
          d="M91.5957 256.031C91.5957 256.699 91.0544 257.24 90.3866 257.24C89.7187 257.24 89.1774 256.699 89.1774 256.031C89.1774 255.363 89.7187 254.822 90.3866 254.822C91.0544 254.822 91.5957 255.363 91.5957 256.031Z"
          fill="#EEF4FF"
          stroke="#EAF1FF"
          stroke-width="1.75221"
        />
        <path
          d="M175.811 315.498C241.194 315.498 294.199 306.286 294.199 294.923C294.199 283.559 241.194 274.347 175.811 274.347C110.427 274.347 57.4229 283.559 57.4229 294.923C57.4229 306.286 110.427 315.498 175.811 315.498Z"
          fill="#ABD1FF"
        />
        <path
          d="M57.3972 294.933L294.173 294.933L294.173 280.083L57.3972 280.083L57.3972 294.933Z"
          fill="#ABD1FF"
        />
        <path
          d="M175.811 300.649C241.194 300.649 294.199 291.437 294.199 280.073C294.199 268.71 241.194 259.498 175.811 259.498C110.427 259.498 57.4229 268.71 57.4229 280.073C57.4229 291.437 110.427 300.649 175.811 300.649Z"
          fill="#C2DBFF"
        />
        <path
          d="M171.563 289.26C206.175 289.26 234.233 284.865 234.233 279.444C234.233 274.023 206.175 269.628 171.563 269.628C136.951 269.628 108.893 274.023 108.893 279.444C108.893 284.865 136.951 289.26 171.563 289.26Z"
          fill="#E4EEFF"
        />
        <path
          d="M252.387 177.959H99.8815C99.1117 177.959 98.5068 178.592 98.5068 179.334V186.098C98.5068 186.867 99.1392 187.472 99.8815 187.472H103.208L104.473 194.455C104.555 194.978 105.105 195.363 105.738 195.363H136.613L166.14 223.241L117.065 269.595H105.573C104.555 269.595 103.731 270.42 103.731 271.437V271.657C103.731 272.674 104.555 273.499 105.573 273.499H150.827C151.844 273.499 152.669 272.674 152.669 271.657V271.437C152.669 270.42 151.844 269.595 150.827 269.595H135.65L175.406 232.039L215.161 269.595H199.82C198.803 269.595 197.978 270.42 197.978 271.437V271.657C197.978 272.674 198.803 273.499 199.82 273.499H245.541C246.559 273.499 247.383 272.674 247.383 271.657V271.437C247.383 270.42 246.559 269.595 245.541 269.595H234.049L184.836 223.131L214.199 195.39H246.504C247.136 195.39 247.658 195.005 247.768 194.483L249.033 187.5H252.387C253.157 187.5 253.762 186.867 253.762 186.125V179.362C253.762 178.592 253.157 177.959 252.387 177.959ZM195.641 195.39L175.571 214.361L155.501 195.39H195.641ZM140.984 195.39H151.102L173.371 216.423L168.312 221.207L140.984 195.39ZM175.571 218.485L180.492 223.131L175.433 227.915L170.512 223.269L175.571 218.485ZM131.279 269.595H121.464L168.34 225.331L173.261 229.977L131.279 269.595ZM229.678 269.595H219.56L177.605 229.977L182.664 225.193L229.678 269.595ZM182.664 221.069L177.77 216.423L200.04 195.39H209.855L182.664 221.069Z"
          fill="#97CBFF"
        />
        <path
          d="M176.547 361.936L177.329 364.033C179.189 363.212 179.79 361.947 179.857 361.417L179.179 359.6C179.046 360.096 177.369 361.364 176.547 361.936Z"
          fill="#ABD1FF"
        />
        <path
          d="M35.8375 328.687L36.8599 331.427C39.2895 330.354 40.0741 328.701 40.1627 328.009L39.2767 325.635C39.1022 326.282 36.9112 327.939 35.8375 328.687Z"
          fill="#E4EEFF"
        />
        <path
          d="M177.292 336.937C179.826 339.855 183.496 340.155 185.014 339.94V348.092C177.094 347.77 177.886 345.089 177.688 343.48V338.653C177.688 337.881 177.424 337.188 177.292 336.937Z"
          fill="#E4EEFF"
        />
        <path
          d="M107.245 325.134V321.955C104.362 322.124 102.935 323.509 102.582 324.18V326.936C103.006 326.342 105.867 325.487 107.245 325.134Z"
          fill="#C2DBFF"
        />
        <path
          d="M158.788 348.697V345.518C155.906 345.687 154.479 347.072 154.125 347.743V350.498C154.549 349.905 157.411 349.05 158.788 348.697Z"
          fill="#97CBFF"
        />
        <path
          d="M108.353 366.063L106.116 365.972C106.153 368.005 107.086 369.048 107.548 369.316L109.486 369.396C109.081 369.08 108.562 367.043 108.353 366.063Z"
          fill="#C2DBFF"
        />
        <path
          d="M65.4067 306.652L63.1701 306.56C63.2063 308.593 64.1393 309.637 64.6013 309.905L66.5397 309.984C66.1344 309.669 65.6155 307.631 65.4067 306.652Z"
          fill="#C2DBFF"
        />
        <path
          d="M72.0579 329.574L68.9204 329.062C68.6229 331.934 69.7593 333.565 70.3647 334.022L73.0839 334.467C72.5666 333.952 72.1844 330.991 72.0579 329.574Z"
          fill="#ABD1FF"
        />
        <path
          d="M124.344 344.792L122.837 347.591C125.455 348.809 127.368 348.266 127.997 347.843L129.304 345.418C128.649 345.739 125.725 345.134 124.344 344.792Z"
          fill="#97CBFF"
        />
        <path
          d="M98.8971 339.511C96.1843 342.394 92.2562 342.69 90.6313 342.478V350.532C99.1091 350.214 98.2613 347.565 98.4733 345.976V341.207C98.4733 340.444 98.7558 339.758 98.8971 339.511Z"
          fill="#E4EEFF"
        />
        <path
          d="M142.922 366.354C141.492 365.27 141.17 363.514 141.187 362.772L137.557 363.159C138.108 366.965 139.261 366.455 139.988 366.474L142.137 366.245C142.481 366.208 142.804 366.303 142.922 366.354Z"
          fill="#E4EEFF"
        />
        <path
          d="M62.6485 355.857C60.0291 355.223 58.5302 352.998 58.1082 351.966L53.343 354.679C56.3872 359.588 57.6691 358.194 58.681 357.784L61.5025 356.177C61.9539 355.92 62.4546 355.856 62.6485 355.857Z"
          fill="#97CBFF"
        />
        <path
          d="M253.082 334.572V331.393C255.956 331.563 257.379 332.947 257.731 333.618V336.374C257.309 335.78 254.456 334.925 253.082 334.572Z"
          fill="#C2DBFF"
        />
        <path
          d="M201.69 337.542V334.363C204.564 334.533 205.987 335.918 206.339 336.589V339.344C205.916 338.751 203.063 337.896 201.69 337.542Z"
          fill="#97CBFF"
        />
        <path
          d="M251.977 374.644L254.207 374.552C254.171 376.585 253.241 377.629 252.78 377.897L250.848 377.976C251.252 377.661 251.769 375.623 251.977 374.644Z"
          fill="#C2DBFF"
        />
        <path
          d="M319.017 329.567L316.83 331.496C315.193 329.404 315.278 327.579 315.524 326.928L317.42 325.257C317.269 325.909 318.422 328.402 319.017 329.567Z"
          fill="#E4EEFF"
        />
        <path
          d="M285.593 314.13L288.721 313.617C289.018 316.489 287.884 318.121 287.281 318.578L284.57 319.022C285.085 318.508 285.467 315.546 285.593 314.13Z"
          fill="#ABD1FF"
        />
        <path
          d="M236.033 351.656L237.536 354.455C234.926 355.673 233.018 355.13 232.391 354.707L231.088 352.282C231.741 352.603 234.656 351.998 236.033 351.656Z"
          fill="#97CBFF"
        />
        <path
          d="M271.697 348.092C274.402 350.974 278.318 351.271 279.938 351.059V359.113C271.485 358.795 272.331 356.145 272.119 354.556V349.787C272.119 349.024 271.838 348.339 271.697 348.092Z"
          fill="#E4EEFF"
        />
        <path
          d="M207.323 368.119C208.749 367.035 209.07 365.279 209.053 364.537L212.672 364.924C212.123 368.73 210.973 368.22 210.249 368.239L208.106 368.01C207.763 367.973 207.441 368.068 207.323 368.119Z"
          fill="#E4EEFF"
        />
        <path
          d="M296.718 351.567C299.33 350.933 300.824 348.708 301.245 347.676L305.996 350.389C302.961 355.298 301.683 353.904 300.674 353.494L297.861 351.887C297.411 351.63 296.911 351.566 296.718 351.567Z"
          fill="#97CBFF"
        />
        <defs>
          <linearGradient
            id="paint0_linear_32_6486"
            x1="67.5208"
            y1="91.2372"
            x2="50.6692"
            y2="24.4675"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2258" stop-color="#FAFAFF" />
            <stop offset="0.4946" stop-color="#FBFDFF" />
            <stop offset="1" stop-color="#C2DBFF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_32_6486"
            x1="257.615"
            y1="150.074"
            x2="304.63"
            y2="27.5311"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#EBF3FF" />
            <stop offset="0.333333" stop-color="#F1F6FF" />
            <stop offset="0.533583" stop-color="#FBFDFF" />
            <stop offset="1" stop-color="#C2DBFF" />
          </linearGradient>
        </defs>
      </svg>
    </Box>
  );
}

export default memo(EventEmpty);
